<template>
	<b-container>
		<b-card class="mt-5 mx-auto bg-none border-none">
			<validation-observer v-slot="{ handleSubmit }" ref="validationObserver">
				<form @submit.prevent="handleSubmit(onSubmit)">
					<span>
						<b-row>
							<b-col><h1>{{ $t("invite-user.userinfo_headline") }}</h1></b-col>
						</b-row>
						<b-row>
							<b-col>
								<validation-provider v-slot="{ errors }" rules="required|email">
									<b-form-group :label="$t('signup.email')">
										<b-form-input v-model="enterpriseInfo.owner.email" />
										<small class="text-white d-block bg-secondary px-1">{{ errors[0] }}</small>
									</b-form-group>
								</validation-provider>
							</b-col>
		
						</b-row>
					</span>
					<span>
						<b-row>
							<b-col>
								<b-button variant="primary" type="submit" block>
									{{ $t("invite-user.complete") }}
								</b-button>
							</b-col>
						</b-row>
					</span>
				</form>
			</validation-observer>
		</b-card>
	</b-container>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

export default {
	name: 'Invite',
	components: {
		ValidationProvider,
		ValidationObserver,
	},
	data() {
		return {
			step: 1,
			enterpriseInfo: {
				owner: {
					pronoun: '',
					firstName: '',
					lastName: '',
					email: '',
				},
			},
		};
	},
	mounted() {
		// set up validation rules
		extend('email', {
			...email,
			message: this.$t('signup.error.invalid_email'),
		});

		extend('required', {
			...required,
			message: this.$t('signup.error.field_required'),
		});
	},
	methods: {
		makeErrorToast(title, error) {
			this.$bvToast.toast(`${error}`, {
				title,
				autoHideDelay: 5000,
				appendToast: false,
				variant: 'danger',
			});
		},
		async onSubmit() {
			// submit data to rest endpoint
			const inviteEmail = this.enterpriseInfo.owner.email;
			const enterpriseId = this.$store.getters.getUser.currentEnterprise.id;
			await this.axios
				.post(`/enterprises/${enterpriseId}/invite/${inviteEmail}`, {
					baseUrl: `${window.location.origin}/`,
				})
				.then(() => {
					this.$router.replace('/');
				})
				.catch((e) => {
					this.makeErrorToast('Invite Error', e.response.data);
				});
		},
	},
};
</script>

<style scoped>
.card {
	width: 42rem;
}
</style>
